import React from "react";
import { useNavigate } from "react-router-dom";
import { LANDING_PAGES } from "../../pages/LandingPages/landingPageConfigs";

const TherapiesSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-primary text-[24px] sm:text-[28px] md:text-[32px] font-roboto leading-snug text-center mb-4">
          Our Therapy Services
        </h2>
        <p className="text-center text-gray-500 mb-12 max-w-xl mx-auto text-base">
          Evidence-based online therapy for the challenges that matter most.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {LANDING_PAGES.map((page) => (
            <button
              key={page.slug}
              onClick={() => navigate(`/therapy/${page.slug}`)}
              className="group text-left rounded-2xl overflow-hidden border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-white"
            >
              {/* Card image */}
              <div className="relative h-44 overflow-hidden">
                <img
                  src={page.heroImage}
                  alt={page.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div
                  className="absolute inset-0"
                  style={{ background: `linear-gradient(to top, ${page.color}cc 0%, transparent 60%)` }}
                />
                <h3 className="absolute bottom-3 left-4 text-white font-bold text-lg drop-shadow">
                  {page.title}
                </h3>
              </div>

              {/* Card body */}
              <div className="p-5">
                <p className="text-sm text-gray-500 leading-relaxed mb-4">
                  {page.heroSubtitle.slice(0, 85)}...
                </p>
                <span
                  className="text-sm font-semibold group-hover:underline"
                  style={{ color: page.color }}
                >
                  Learn more →
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TherapiesSection;
